import { FONT_FAMILY } from './constants';

/* eslint-disable import/prefer-default-export */
const axisColor = '#ccc';
const labelColor = '#9e9e9e';
const splitLineStyle = {
  color: ['#ddd'],
  type: 'dashed',
  opacity: 0.6,
};

export const compareSchemaOptions = (metricObj) => {
  const metricName = Object.keys(metricObj)[0];
  const { id } = metricObj;

  return {
    id,
    xAxis: [
      {
        gridIndex: 0,
        type: 'time',
        show: false,
        data: [],
      },
      {
        id: 'time-axis',
        type: 'time',
        splitNumber: 10,
        offset: 15,
        axisLabel: {
          color: labelColor,
          showMinLabel: false,
          fontFamily: FONT_FAMILY,
          hideOverlap: true,
        },
        splitLine: {
          show: true,
          lineStyle: splitLineStyle,
        },
        axisLine: {
          lineStyle: {
            color: axisColor,
          },
        },
        axisTick: {
          show: false,
          lineStyle: {
            color: axisColor,
          },
        },
        gridIndex: 1,
      },
    ],
    yAxis: [
      {
        gridIndex: 0,
        show: false,
      },
      {
        id: 'value-axis',
        type: 'value',
        splitNumber: 3,
        axisLabel: {
          color: labelColor,
          fontFamily: FONT_FAMILY,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: splitLineStyle,
        },
        gridIndex: 1,
      },
    ],
    dataZoom: [
      {
        bottom: 25,
        show: true,
        realtime: false,
        start: 0,
        end: 100,
        xAxisIndex: [0],
        minSpan: 3,
        height: '10px',
        handleSize: '200%',
        textStyle: {
          fontSize: 11,
          lineHeight: 10,
        },
        dataBackground: {
          lineStyle: {
            opacity: 0,
          },
          areaStyle: {
            opacity: 0,
          },
        },
      },
    ],
    grid: [
      {
        top: -10,
        bottom: 40,
        left: 45,
        right: 45,
        height: 0,
      },
      {
        top: 15,
        bottom: 40,
        left: 45,
        right: 45,
      },
    ],
    toolbox: {
      show: false,
    },
    tooltip: {
      trigger: 'axis',
      textStyle: { fontFamily: FONT_FAMILY },
    },
    brush: {
      brushType: 'lineX',
      // seriesIndex: [0],
      brushLink: [0],
      xAxisIndex: [1],
      transformable: false,
      throttleType: 'debounce',
      throttleDelay: 300,
      brushStyle: {
        borderWidth: 1,
        color: 'rgba(120,140,180,0.3)',
        borderColor: 'rgb(224, 224, 224,0.8)',
      },
    },
    _metric: metricName,
    _title: metricObj[metricName].displayName,
    _shortMetric: metricObj[metricName].short,
    _unit: metricObj[metricName].unit,
    _aggregate: `totals.${metricName}`,
    _deviation: 'totals.deviation',
  };
};

export const compareSchemaChartSeriesOptions = (param) => {
  const { data } = param;

  return {
    data,
    type: 'line',
    symbol: 'circle',
    symbolSize: 8,
    hoverAnimation: false,
    showSymbol: false,
    itemStyle: {
      color: 'filterColor',
    },
    lineStyle: {
      width: 0.75,
    },
  };
};
